import { z } from 'zod';
import { MediaSchema } from './medias.js';
import { ProseBilingueSchema, TexteBilingueSchema } from './textes.js';
export const MembreEquipeSchema = z.object({
    nom: z.string().min(1),
    role: TexteBilingueSchema,
    email: z.email().optional(),
});
/** Page éditoriale simple : un titre, une prose, éventuellement une image. */
export const PageTexteSchema = z.object({
    titre: TexteBilingueSchema,
    corps: ProseBilingueSchema,
    media: MediaSchema.optional(),
});
export const PageLaGalerieSchema = PageTexteSchema.extend({
    equipe: z.array(MembreEquipeSchema),
});
export const PageContactSchema = z.object({
    titre: TexteBilingueSchema,
    corps: ProseBilingueSchema.optional(),
    /** Phrase d'appel de l'inscription à la lettre d'information. */
    newsletter: TexteBilingueSchema.optional(),
});
/**
 * Les quatre pages fixes du site (section 3.4). Archives, éditions et viewing
 * rooms sont hors périmètre S6 : elles arrivent avec la finalisation.
 */
export const PagesSchema = z.object({
    laGalerie: PageLaGalerieSchema,
    contact: PageContactSchema,
    mentions: PageTexteSchema,
    confidentialite: PageTexteSchema,
});
//# sourceMappingURL=pages.js.map